import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

export default function CardBadge({ className, children }) {
  return (
    <div
      className={classnames(
        'CardBadge inline-flex items-center justify-between br-pill no-select font-12',
        className
      )}
      style={{ padding: '6px 10px' }}
      data-test-id="CardBadge"
    >
      <span>{children}</span>
    </div>
  );
}

CardBadge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

CardBadge.defaultProps = {
  className: 'bg-gray-300'
};
